<template>
  <div>
    <router-view/>
    <delete-job-dialog/>
  </div>
</template>

<script>
import DeleteJobDialog from './DeleteJobDialog.vue';

export default {
  name: 'CompanyJobsJob',
  components: {
    DeleteJobDialog,
  },
};
</script>
